export const footer = {
  footerTitleGame: "The Best Games",
  footerTitleGameCasino: "Casino",
  footerTitleGameLottery: "Lottery",
  footerTitleGameGames: "Games",
  footerTitleSports: "Sports",
  footerTitleGameSlots: "Slots",
  footerTitleGameMinigame: "Minigames",
  footerTitleTestimonials: "Testimonials",
  footerTitleNews: "News",
  footerTitleLiga: "Winning Leagues",
  footerTitleLigaEsports: "E-Sports",
  footerTitleLigaLeague: "The League",
  footerTitleLigaFootball: "UEFA Champions League",
  footerTitleSupport: "Support",
  footerTitleHelp: "Help Center",
  footerTitleTerms: "Terms and Conditions",
  footerTitleSocial: "Follow us",
  footerTitleApp: "Download our App",
  footerTitlePromotions: "Promotions",
  footerTitleResponsibleGambling: "Gamble responsibly. Only for 18+.",
  footerTitleSafeGame: "Everything for a safer game",
  footerInfoTitle: "Information",
  footerCategoriesTitle: "Categories",
  footerContactSupport: "Chat with us",
  footerSupportDesc: "Questions? We're here.",
  footerPromoTitle: "Free spins!",
  footerPromoDesc: "1 free spin for every 40 Bs on your first deposit",
  footerPromoAvailable: "Available for Android and iOS",
  footerWinAppTitle: "Download the Windows app and play on your PC",
  footerInstallBtn: "Install",
  footerRegisterBtn: "Sign Up",
  footerGPlayTitle: "Download on Google Play",
  footerGPlayDesc: "The best gaming experience on your Android",
  footerIOSTitle: "Download on App Store",
  footerIOSDesc: "Available for iPhone and iPad",
  footerDownloadBtn: "Download",
  footerGetItOn: "GET IT ON",
  footerDownloadOn: "Download on the",
};
